module.exports = __webpack_public_path__ + "static/visionBg-160423db7bde9b97ea6bd0e3ef49b5ce.png";